/** Ordinary sign-out stays best effort; account deletion requires a confirmed result. */
export async function completeAuthLogout(logout: () => Promise<void>, throwOnError: boolean) {
  try {
    await logout();
  } catch (error) {
    console.warn('Auth0 logout failed:', error);
    if (throwOnError) throw error;
  }
}
